export function parseError (error: unknown, fallbackMessage: string) {
  if (error instanceof Error) {
    return { message: error.message, errors: undefined }
  }

  if (error && typeof error === 'object') {
    const { message, errors } = error as {
      message: string;
      errors?: string[];
    }

    return { message, errors }
  }

  return {
    message: fallbackMessage,
    errors: undefined,
  }
}

export function parseNumber (value: number | string | null) {
  if (typeof value === 'number') {
    return value
  }

  if (typeof value === 'string') {
    return parseFloat(value.replace(/[^\d.]/g, ''))
  }

  return null
}

export const emitEmployerOnboardingEvent = (event: string, data: Record<string, any>) => {
  window.segment?.track(event, data)
}
